"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGoldCounter = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@21st-night/core");
var _a = __read(core_1.createContext(), 2), hook = _a[0], Provider = _a[1];
var GoldCounterProvider = function (_a) {
    var children = _a.children, value = _a.value;
    var user = core_1.useUser();
    var _b = __read(react_1.useState(user.statistics || {}), 2), previousStatistics = _b[0], setPreviousStatistics = _b[1];
    var _c = __read(react_1.useState(false), 2), popoverOpen = _c[0], setPopoverOpen = _c[1];
    var _d = __read(react_1.useState(false), 2), trophiesDialogOpen = _d[0], setTrophiesDialogOpen = _d[1];
    var _e = __read(react_1.useState('sword'), 2), purchaseTrophyId = _e[0], setPurchaseTrophyId = _e[1];
    var _f = __read(react_1.useState(false), 2), purchaseTrophyDialogOpen = _f[0], setPurchaseTrophyDialogOpen = _f[1];
    react_1.useEffect(function () {
        if (user.statistics) {
            var longestStreak = user.statistics['longest-streak'];
            if (longestStreak !== previousStatistics['longest-streak']) {
                if ([2, 5, 10, 30, 90, 120, 180].includes(longestStreak)) {
                    user.addAchievement('longest-streak', longestStreak);
                }
            }
            var cardsCreated = user.statistics['cards-created'];
            if (cardsCreated !== previousStatistics['cards-created']) {
                if ([1, 10, 50, 100, 200, 500, 1000].includes(cardsCreated)) {
                    user.addAchievement('cards-created', cardsCreated);
                }
            }
            var cardsReviewed = user.statistics['cards-reviewed'];
            if (cardsReviewed !== previousStatistics['cards-reviewed']) {
                if ([1, 10, 50, 100, 200, 500, 1000].includes(cardsReviewed)) {
                    user.addAchievement('cards-reviewed', cardsReviewed);
                }
            }
            var cardsMastered = user.statistics['cards-mastered'];
            if (cardsMastered !== previousStatistics['cards-mastered']) {
                if ([1, 10, 50, 100, 200, 500, 1000].includes(cardsMastered)) {
                    user.addAchievement('cards-mastered', cardsMastered);
                }
            }
            var notesCreated = user.statistics['notes-created'];
            if (notesCreated !== previousStatistics['notes-created']) {
                if ([1, 10, 50, 100, 200, 500, 1000].includes(notesCreated)) {
                    user.addAchievement('notes-created', notesCreated);
                }
            }
            var decksCreated = user.statistics['decks-created'];
            if (decksCreated !== previousStatistics['decks-created']) {
                if ([1, 5].includes(decksCreated)) {
                    user.addAchievement('decks-created', decksCreated);
                }
            }
            var studyPlansCreated = user.statistics['study-plans-created'];
            if (studyPlansCreated !== previousStatistics['study-plans-created']) {
                if ([1].includes(studyPlansCreated)) {
                    user.addAchievement('study-plans-created', studyPlansCreated);
                }
            }
            var itemsCompleted = user.statistics['items-completed'];
            if (itemsCompleted !== previousStatistics['items-completed']) {
                if ([1, 10, 50].includes(itemsCompleted)) {
                    user.addAchievement('items-completed', itemsCompleted);
                }
            }
            var timersSet = user.statistics['timers-set'];
            if (timersSet !== previousStatistics['timers-set']) {
                if ([1, 10, 50].includes(timersSet)) {
                    user.addAchievement('timers-set', timersSet);
                }
            }
            var analyticsViewed = user.statistics['analytics-viewed'];
            if (analyticsViewed !== previousStatistics['analytics-viewed']) {
                if ([1].includes(analyticsViewed)) {
                    user.addAchievement('analytics-viewed', analyticsViewed);
                }
            }
            var analyticsEmails = user.statistics['analytics-emails'];
            if (analyticsEmails !== previousStatistics['analytics-emails']) {
                if ([1].includes(analyticsEmails)) {
                    user.addAchievement('analytics-emails', analyticsEmails);
                }
            }
            var deckShareAnalytics = user.statistics['deck-share-analytics'];
            if (deckShareAnalytics !== previousStatistics['deck-share-analytics']) {
                if ([1].includes(deckShareAnalytics)) {
                    user.addAchievement('deck-share-analytics', deckShareAnalytics);
                }
            }
            var deckShareTeachers = user.statistics['deck-share-teachers'];
            if (deckShareTeachers !== previousStatistics['deck-share-teachers']) {
                if ([1].includes(deckShareTeachers)) {
                    user.addAchievement('deck-share-teachers', deckShareTeachers);
                }
            }
            var deckShareCollaborators = user.statistics['deck-share-collaborators'];
            if (deckShareCollaborators !==
                previousStatistics['deck-share-collaborators']) {
                if ([1, 2, 5].includes(deckShareCollaborators)) {
                    user.addAchievement('deck-share-collaborators', deckShareCollaborators);
                }
            }
            setPreviousStatistics(user.statistics);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.statistics]);
    var openPopover = react_1.useCallback(function () {
        setPopoverOpen(true);
    }, []);
    var closePopover = react_1.useCallback(function () {
        setPopoverOpen(false);
    }, []);
    var openTrophiesDialog = react_1.useCallback(function () {
        setTrophiesDialogOpen(true);
    }, []);
    var closeTrophiesDialog = react_1.useCallback(function () {
        setTrophiesDialogOpen(false);
    }, []);
    var openPurchaseTrophyDialog = react_1.useCallback(function () {
        setPurchaseTrophyDialogOpen(true);
    }, []);
    var closePurchaseTrophyDialog = react_1.useCallback(function () {
        setPurchaseTrophyDialogOpen(false);
    }, []);
    var selectPurchaseTrophy = react_1.useCallback(function (trophyId) {
        setPurchaseTrophyId(trophyId);
    }, [setPurchaseTrophyId]);
    var purchaseTrophy = react_1.useCallback(function () {
        user.purchaseTrophy(purchaseTrophyId, 18);
        closePurchaseTrophyDialog();
    }, [closePurchaseTrophyDialog, purchaseTrophyId, user]);
    return (react_1.default.createElement(Provider, { value: {
            purchasedTrophies: user.trophies || [],
            openPopover: openPopover,
            closePopover: closePopover,
            popoverOpen: popoverOpen,
            openTrophiesDialog: openTrophiesDialog,
            openPurchaseTrophyDialog: openPurchaseTrophyDialog,
            closeTrophiesDialog: closeTrophiesDialog,
            closePurchaseTrophyDialog: closePurchaseTrophyDialog,
            trophiesDialogOpen: trophiesDialogOpen,
            purchaseTrophyDialogOpen: purchaseTrophyDialogOpen,
            purchaseTrophyId: purchaseTrophyId,
            purchaseTrophy: purchaseTrophy,
            selectPurchaseTrophy: selectPurchaseTrophy,
            value: value,
            active: value > 0,
            streakFreeze: user.streakFreeze || false,
        } }, children));
};
exports.useGoldCounter = hook;
exports.default = GoldCounterProvider;
//# sourceMappingURL=GoldCounterProvider.js.map